export default __webpack_public_path__ + "static/media/default-image-square.1051f8f6.svg";